<section class="intro module-gmix">
  <div class="container">
    <div class="gennius__bloque">
      <div class="gennius__left">
        <img loading="lazy" class="image" src="./assets/img/gmix/logo-one.png" alt="gennius">
      </div>
      <div class="gennius__right">
        <h1>The First ‘One’ Token: </h1>
        <p><strong>One Token (GMIX)</strong> is an ERC-20 EVM token that offers interoperability and instant swaps between loyalty programs, fiat currencies, and the crypto market, allowing users to pay for everyday essentials at over 150 million merchants around the world, as well as for NFTs and purchases in Web3. </p>

        <a class="more" (click)="openSectionBenefits('1')"></a>

      </div>
    </div>
  </div>
  <video autoplay="" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true"
    poster="./assets/img/gmix/poster-video-first.webp">
    <source
      src="https://player.vimeo.com/progressive_redirect/playback/1000447514/rendition/720p/file.mp4?loc=external&signature=b86c119ff89329b17d570b24b562f0b481417c3b8b514cd46256b2e95a1a8c05"
      type="video/mp4">
  </video>
  <div class="filter"></div>
</section>

<div class="expansive-gmix" id="ancla">
  <div class="container">
    <p class="text-intro">A Unique Stablecoin, multi-source backed: bank rewards, digital assets and fiat currencies like USD and Dirham. It is designed to provide stability and seamless spending across web3 and Global Markets, al within One Wallet.</p>
    <div class="module">
      <div class="bl">
        <div class="image">
          <img src="./assets/img/gmix/module-image1.png" alt="">
        </div>
        <p><strong>One Token </strong> has included a revolutionary technology called “<strong>CC Robot</strong>” (Currency Cron Robot). Developed in Java Spring Boot, <strong>CC Robot</strong> was designed to enable users to connect all sources of rewards points, digital assets, and payment networks available in the global marketplace.</p>
      </div>
      <div class="bl">
        <div class="image">
          <img src="./assets/img/gmix/module-image2.png" alt="">
        </div>
        <p><strong>CC Robot</strong> can be executed in real time or through a cronjob, which allows for the preprogramming of the robot’s scheduling.</p>
      </div>
      <div class="bl">
        <div class="image">
          <img src="./assets/img/gmix/module-image3.png" alt="">
        </div>
        <p>It was designed to run intelligence, allowing the implementation of business rules - accurately and efficiently - including customized accrual engine, - spending preferences, - fraud control, - and analytics, among others.</p>
      </div>
    </div>
    <div class="module module--block">
      <div class="bl w-438">
        <div class="image">
          <img src="./assets/img/gmix/on-off.png" alt="">
          <span>On & Off-Ramp <br> Capabilities</span>
        </div>
        <p><strong>One Token </strong> (GMIX) redefines value transfer by bridging fiat, crypto, and rewards points across banking systems, DeFi, and CeFi platforms. It empowers users to move seamlessly between worlds — converting One Token into fiat, crypto, or rewards — unlocking true liquidity, freedom, and global usability without barriers. 
          <br>
          <br>
          Track <strong>One Token</strong>  Performance
          <a class="link-polygon" href="https://polygonscan.com/token/0x5a3999445d4cb78b8560b9083eee7db56f9f046e" target="_blank">PolygonScan</a>
        </p>


      </div>
      <div class="colum-right">
            <div class="coinmarketcap-currency-widget"
              data-currencyid="34421"
              data-base="USD"
              data-secondary=""
              data-ticker="true"
              data-rank="false"
              data-marketcap="false"
              data-volume="false"
              data-statsticker="true"
              data-stats="USD">
          </div>

        <div class="bl">
          <img src="" alt="">
          <p>Our turnkey solution is ready to instantly connect your loyalty programs, fiat money, and cryptocurrencies, for you to start earning on every transaction and redeeming without currency limits or merchant constraints, globally and locally.</p>
        </div>
      </div>

    </div>

    <!-- <a class="menos bottom" (click)="closeSectionBenefits('2')"></a> -->

  </div>
</div>

<section class="one">
  <div class="container">
    <div class="gennius__bloque">
      <div class="gennius__left">
        <h1>The Future of Digital Currency<br> is here</h1>
        <p>Backed by multi-rewards from global banks and integrated with leading stablecoins like USDC, PYUSD, and Tether, One Token offers a secure, stable, and versatile currency for every transaction—whether in fiat or crypto.

        </p>
        <!-- <button>Activate your GMIX Wallet Now</button> -->
      </div>
      <div class="gennius__right">
        <img loading="lazy" class="bg-future" src="./assets/img/gmix/bg-future.png" alt="gennius">
      </div>
    </div>
  </div>
</section>

<section class="two">
  <div class="container">
    <div class="gennius__bloque">
      <div class="gennius__left">

        <img loading="lazy" class="iphone" src="./assets/img/gmix/imagine-8.png" alt="gennius">

        <img loading="lazy" class="graphic-1" src="./assets/img/gmix/graphic-10.png" alt="gennius">
        <img loading="lazy" class="graphic-2" src="./assets/img/gmix/graphic-11.png" alt="gennius">
        <img loading="lazy" class="graphic-4" src="./assets/img/gmix/graphic-12.png" alt="gennius">
        <img loading="lazy" class="logo-1" src="./assets/img/gmix/currency.png" alt="gennius">

        <img loading="lazy" class="oval" src="./assets/img/gmix/oval.png" alt="gennius">

      </div>
      <div class="gennius__right gennius__right--cero">
        <h1>Why One Token?</h1>
        <ul>
          <li><strong>Unified Wallet:</strong> Manage your fiat, crypto, and rewards in one place.</li>
          <li><strong>Global Reach:</strong> Spend at over 150 million merchants worldwide.</li>
          <li><strong>Instant Operability:</strong> Integrated with Apple Pay and Google Pay, making transactions seamless.</li>
          <li><strong>Security and Stability:</strong> Backed by multi-rewards programs and the most trusted stablecoins.</li>
        </ul>
      </div>
    </div>
  </div>


</section>

<app-gmix-world></app-gmix-world>

<section class="three">
  <div class="container">
    <div class="gennius__bloque">
      <div class="gennius__left">
        <h1>Seamless for Crypto Holders</h1>
        <p>With 500 million crypto holders globally, <strong> One Token </strong>offers you a single, unified wallet to manage all your assets and rewards, making digital payments as easy as cash. Experience seamless transactions in both the real world and the digital space.
        </p>

      </div>
      <div class="gennius__right gennius__right--cero">
        <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-7.webp" alt="gennius">
        <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-8.webp" alt="gennius">
        <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-9.webp" alt="gennius">
        <img loading="lazy" class="logo-1" src="./assets/img/gmix/currency.png" alt="gennius">

        <img loading="lazy" class="oval" src="./assets/img/gmix/oval.png" alt="gennius">

      </div>
    </div>
  </div>
</section>

<section class="four logo-cymi-aos imagine_explore">
  <div class="container">
    <div class="gennius__bloque">
      <div class="gennius__left">
        <img loading="lazy" class="phone" src="./assets/img/imagine/phone-1.webp" alt="gennius">
        <img loading="lazy" class="oval" src="./assets/img/gmix/oval.png" alt="gennius">

      </div>
      <div class="gennius__right gennius__right--padding">
        <h1>How One Token<br>Works</h1>
        <ul>
          <li>
            <img loading="lazy" class="icon-list" src="./assets/img/gmix/icon1.png" alt="gennius">
            <p>Connect your wallet (MetaMask, Coinbase, Fuze, etc.).</p>
          </li>
          <li>
            <img loading="lazy" class="icon-list" src="./assets/img/gmix/icon2.png" alt="gennius">
            <p>Transfer in your tokens and crypto into your One Wallet.</p>
          </li>
          <li>
            <img loading="lazy" class="icon-list" src="./assets/img/gmix/icon3.png" alt="gennius">
            <p>Start spending at global merchants or unlock exclusive rewards with your tokens.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>


<section class="five">
  <div class="container">
    <div class="content">
      <h1>One Token and Gennius XYZ</h1>
      <p>Powered by <strong>Gennius XYZ, One Token </strong>supports the mission of unifying the world’s payments into one seamless solution. Join us in making One Currency, One Wallet,  and One Global Marketplace a reality.

      </p>


      <a class="link_button gmix" href="https://gmix.io/whitepaper.pdf" target="_blank"><span class="icon-download"></span>Download White Paper</a>
    </div>
  </div>
</section>

<app-footer></app-footer>